module.exports = __webpack_public_path__ + "img/sort-numeric-down.0191eaeb.svg";